import { PageController } from '@client/components/_core/layout/PageController';
import { IndicatorReprocessView } from '@client/components/admin-console/IndicatorReprocessView';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/advanced/indicators/incidents')({ component: Indicators });

function Indicators() {
    const { trpc } = useTrpc();
    const reprocessIncidentIndicator = trpc.admin.indicator.reprocessIncidentIndicator.useMutation();

    return (
        <PageController route={Route}>
            <IndicatorReprocessView
                entity="incident"
                idFieldName="incidentId"
                onSubmit={({ orgId, entityId }) =>
                    reprocessIncidentIndicator.mutateAsync({ orgId, incidentId: entityId })
                }
            />
        </PageController>
    );
}
